const getters = {
    token: state => state.user.token,
    userAllInfo:state=>state.user.userAllInfo,
    id:state=>state.user.id,
    userInfo: state => state.userInfo
}

export default getters
